<mat-card>
  <mat-card-content>
    <mat-form-field appearance="outline" class="notes-field">
      <mat-label>Notes</mat-label>
      <textarea matInput
                [(ngModel)]="noteText"
                rows="10"
                placeholder="Add notes here...">
      </textarea>
    </mat-form-field>

    <div class="notes-footer">
      @if (lastSavedDate) {
        <span class="last-saved-info">
          Last saved by {{ lastSavedAuthor }} on {{ getFormattedDate() }}
        </span>
      }

      <button mat-raised-button
              color="primary"
              [disabled]="!isDirty || saving"
              (click)="save()">
        <mat-icon>save</mat-icon>
        {{ saving ? 'Saving...' : 'Save' }}
      </button>
    </div>
  </mat-card-content>
</mat-card>
